import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import Accounts from './containers/Accounts';

export const POST_CRM = {
  Helmet: lazy(() => import('./components/Helmet')),
  Accounts,
  ContactForm: lazy(() => import('./containers/Contacts/containers/ContactForm')),
  AccountFormRenderer: lazy(() => import('./components/AccountFormRenderer')),
  Contacts: lazy(() => import('./containers/Contacts')),
  ContactHistory: lazyNamed(() => import('./containers/Contacts/containers/History'), 'History'),
};

export { ContactFormSearchParams } from './types';
